import { defineStore } from "pinia";
import config from '@/config'

export const useCustomizerStore = defineStore({
    id: "customizer",
    state: () => ({
        Sidebar_drawer: config.Sidebar_drawer,
        Customizer_drawer: config.Customizer_drawer,
        mini_sidebar: localStorage.getItem('mini_sidebar') === 'true' ? true : 
                      localStorage.getItem('mini_sidebar') === 'false' ? false : 
                      config.mini_sidebar,
        setHorizontalLayout: config.setHorizontalLayout,
        setRTLLayout: config.setRTLLayout,
        theme: localStorage.getItem('theme') || config.actTheme,
        boxed: localStorage.getItem('boxed') === 'true' ? true : 
               localStorage.getItem('boxed') === 'false' ? false : 
               config.boxed,
        setBorderCard: localStorage.getItem('setBorderCard') === 'true' ? true : 
                       localStorage.getItem('setBorderCard') === 'false' ? false : 
                       config.setBorderCard,
        sidebarWidth: localStorage.getItem('sidebarWidth') || config.sidebarWidth,
        fontSize: localStorage.getItem('fontSize') || config.fontSize,
        compactMode: localStorage.getItem('compactMode') === 'true' ? true : 
                     localStorage.getItem('compactMode') === 'false' ? false : 
                     config.compactMode,
        animations: localStorage.getItem('animations') === 'true' ? true : 
                    localStorage.getItem('animations') === 'false' ? false : 
                    config.animations,
    }),
    getters: {},
    actions: {
        SET_SIDEBAR_DRAWER() {
            this.Sidebar_drawer = !this.Sidebar_drawer;
        },
        SET_MINI_SIDEBAR(payload: any) {
            this.mini_sidebar = payload;
            localStorage.setItem('mini_sidebar', payload.toString());
        },
        SET_CUSTOMIZER_DRAWER(payload: any) {
            this.Customizer_drawer = payload;
        },
        SET_LAYOUT(payload: any) {
            this.setHorizontalLayout = payload;
        },
        SET_THEME(payload: any) {
            this.theme = payload;
            localStorage.setItem('theme', payload);
        },
        // Alias for compatibility
        setTheme(theme: string) {
            this.SET_THEME(theme)
        },
        SET_CARD_BORDER(payload: any) {
            this.setBorderCard = payload;
            localStorage.setItem('setBorderCard', payload.toString());
        },
        SET_SIDEBAR_WIDTH(payload: 'compact' | 'default' | 'wide') {
            this.sidebarWidth = payload;
            localStorage.setItem('sidebarWidth', payload);
        },
        SET_FONT_SIZE(payload: 'small' | 'medium' | 'large') {
            this.fontSize = payload;
            localStorage.setItem('fontSize', payload);
        },
        SET_COMPACT_MODE(payload: boolean) {
            this.compactMode = payload;
            localStorage.setItem('compactMode', payload.toString());
        },
        SET_ANIMATIONS(payload: boolean) {
            this.animations = payload;
            localStorage.setItem('animations', payload.toString());
        },
        SET_BOXED(payload: boolean) {
            this.boxed = payload;
            localStorage.setItem('boxed', payload.toString());
        }
    },
});

// Auto-persist setup
export const initCustomizerPersistence = () => {
    const store = useCustomizerStore();
    store.$subscribe((_, state) => {
        localStorage.setItem('mini_sidebar', state.mini_sidebar.toString());
        localStorage.setItem('theme', state.theme);
        localStorage.setItem('boxed', state.boxed.toString());
        localStorage.setItem('setBorderCard', state.setBorderCard.toString());
        localStorage.setItem('sidebarWidth', state.sidebarWidth);
        localStorage.setItem('fontSize', state.fontSize);
        localStorage.setItem('compactMode', state.compactMode.toString());
        localStorage.setItem('animations', state.animations.toString());
    });
};
